import { DialogMonitorProvisionComponent } from 'src/homepage/quick-actions/dialog-monitor-provision/dialog-monitor-provision.component';
import { HomeService } from './../shared/home.service';
import { Component, OnInit, OnChanges } from '@angular/core';
import { LoggerService } from 'src/shared/logger/logger.service';
import { Levels } from 'src/shared/logger/levels.enum';
import { MatDialog } from '@angular/material/dialog';
import { InsertUnitsComponent } from 'src/system-profile-manager/dialog-insert-system/insert.systems.component';
import { DialogConfirmationComponent } from 'src/shared/Dialogs/dialog-confirmation/dialog.confirmation.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BulkActionsDialogComponent } from 'src/shared/Dialogs/bulk-actions/dialog.bulkActions.component';
import jwt_decode from 'jwt-decode';
import { WallpaperUploadDialogComponent } from 'src/shared/Dialogs/wallpaper-upload/dialog.wallpaperUpload.component';

@Component({
  selector: 'quick-action-tabs',
  templateUrl: './quick-actions.component.html',
  styleUrls: ['./quick-actions.component.css']
})
export class QuickActionsComponent implements OnInit { //the received data to be drawn on chart
  public lineChartData1: Array<object> = [{ data: [0, 150, 110, 240, 200, 200, 300, 200, 380, 300, 400, 380], label: 'no. of units added' }];
  //the received labels to be shown on x-axis
  public lineChartLabels1: Array<string> = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
  //chart options
  public lineChartOptions1 = {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true
          },
          gridLines: {
            color: 'rgba(0, 0, 0, 0.1)'
          }
        }
      ],
      xAxes: [
        {
          gridLines: {
            color: 'rgba(0, 0, 0, 0.1)'
          }
        }
      ]
    },
    lineTension: 10,
    responsive: true,
    maintainAspectRatio: false,
    elements: { line: { tension: 0 } }
  };
  //chart colors
  public lineChartColors1: Array<object> = [
    {
      // grey
      backgroundColor: 'rgba(6,215,156,0.0)',
      borderColor: 'rgba(57,139,247,1)',
      pointBackgroundColor: 'rgba(57,139,247,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(57,139,247,0.5)'
    },
    {
      // dark grey
      backgroundColor: 'rgba(57,139,247,0.0)',
      borderColor: 'rgba(57,139,247,1)',
      pointBackgroundColor: 'rgba(57,139,247,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(57,139,247,0.5)'
    }
  ];
  public lineChartLegend1 = false;
  public lineChartType1 = 'line';

  private user_info_obj: { name: string, role: string } = null;


  constructor(private loggerService: LoggerService,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog,
    private homeService: HomeService) {
  }
  ngOnInit(): void {
    if (!this.user_info_obj) { this.user_info_obj = jwt_decode(localStorage.getItem('accessToken')); }
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 8000,
      panelClass: ['mat-toolbar', 'mat-primary']

    });
  }

  openAddDialog() {
    const dialogRef = this.dialog.open(InsertUnitsComponent, {
      minWidth: '95vw',
      maxWidth: '95vw',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      this.homeService.getVMSStatistics().subscribe(data => {
        this.homeService.dataToBeTransmitted.next(data.data);
      }, err => {
        this.loggerService.log("QuickActionsComponent", err.error.message ? err.error.message : "Error while sending data", Levels.error)
      })
    });
  }

  openProvisionDIalog() {
    const dialogRef = this.dialog.open(DialogMonitorProvisionComponent, {
      minWidth: '95vw',
      maxWidth: '95vw',
      minHeight: '50%',
      data: "Provision",
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      this.homeService.getVMSStatistics().subscribe(data => {
        this.homeService.dataToBeTransmitted.next(data.data);
      }, err => {
        this.loggerService.log("QuickActionsComponent", err.error.message ? err.error.message : "Error while sending data", Levels.error)
      })
    });
  }

  openMonitorDialog() {
    const dialogRef = this.dialog.open(DialogMonitorProvisionComponent, {
      minWidth: '95vw',
      maxWidth: '95vw',
      data: "Monitor",
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      this.homeService.getVMSStatistics().subscribe(data => {
        this.homeService.dataToBeTransmitted.next(data.data);
      }, err => {
        this.loggerService.log("QuickActionsComponent", err.error.message ? err.error.message : "Error while sending data", Levels.error)
      })
    });
  }

  openConfirmationDialog(): void {
    const dialogRef = this.dialog.open(DialogConfirmationComponent, {
      width: '450px',
      data: { title: "Pull All Units Configuration Files", message: "Confirm pulling all VMS units configuration files. This process takes time so please confirm or cancel" },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.homeService.pullAllUnitsConfigurationFiles(this.user_info_obj.name).subscribe(data => {
          this.openSnackBar("Pulling all units configuration files has begun, this process may takes several minutes.", "Processing");
        }, err => {
          this.openSnackBar(err.error?.message ? err.error?.message : "Error while processing your request", "Error");
        })
      }
    });
  }

  openBulkActionsDialog(): void {
    const dialogRef = this.dialog.open(BulkActionsDialogComponent, {
      minWidth: '95vw',
      maxWidth: '95vw',
      minHeight: '50%',
      data: {},
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.homeService.getVMSStatistics().subscribe(data => {
          this.homeService.dataToBeTransmitted.next(data.data);
        }, err => {
          this.loggerService.log("QuickActionsComponent", err.error.message ? err.error.message : "Error while sending data", Levels.error)
        })
      }
    });
  }


  openWallpaperUploadActionDialog(): void {
    const dialogRef = this.dialog.open(WallpaperUploadDialogComponent, {
      minWidth: '95vw',
      maxWidth: '95vw',
      minHeight: '50%',
      data: {},
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.homeService.getVMSStatistics().subscribe(data => {
          this.homeService.dataToBeTransmitted.next(data.data);
        }, err => {
          this.loggerService.log("QuickActionsComponent", err.error.message ? err.error.message : "Error while sending data", Levels.error)
        })
      }
    });
  }

  openConfirmationDialogForPhonebookRefresh() {
    const dialogRef = this.dialog.open(DialogConfirmationComponent, {
      width: '450px',
      data: { title: "Refresh Phonebook", message: `Confirm the update/refresh for phonebook` },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.homeService.refreshPhonebook(this.user_info_obj.name).subscribe(data => {
          this.openSnackBar("Phonebook reloaded successfully.", "Done");
        }, err => {
          this.openSnackBar(err.error?.message ? err.error?.message : "Error while processing your request", "Error");
        })
      }
    });
  }

}
